import React, { useRef, useState, useLayoutEffect, useEffect } from "react";

// A drop-in replacement for recharts' ResponsiveContainer that measures the
// parent with a ResizeObserver and passes explicit numeric width/height to
// its child chart. Fixes the well-known recharts+React 19 "svg width 0" bug.
export const SizedChart = ({ height = 320, className = "px-2 py-6", children }) => {
  const wrapRef = useRef(null);
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    const el = wrapRef.current;
    if (!el) return;
    setWidth(el.clientWidth || 0);
  }, []);

  useEffect(() => {
    const el = wrapRef.current;
    if (!el || typeof ResizeObserver === "undefined") return;
    const ro = new ResizeObserver((entries) => {
      const w = entries[0]?.contentRect?.width || 0;
      if (w) setWidth(Math.round(w));
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <div ref={wrapRef} className={className} style={{ width: "100%" }}>
      {width > 0 &&
        React.cloneElement(children, { width, height })}
    </div>
  );
};

export default SizedChart;
